/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Slow_Anteater_FondInputs */

const fr_kind_slow_anteater_fond = /** @type {(inputs: Kind_Slow_Anteater_FondInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Répétitions min`)
};

/**

* @param {Kind_Slow_Anteater_FondInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const kind_slow_anteater_fond = /** @type {((inputs?: Kind_Slow_Anteater_FondInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Slow_Anteater_FondInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_kind_slow_anteater_fond(inputs)
});